import React, {useState} from 'react';
import parse from 'html-react-parser';
import './header-style.scss';
import {useRecoilValue} from "recoil";
import {userAtom} from "../../../store/UserStore";
import {ReactComponent as LogoBack} from './images/back.svg';
import {ReactComponent as LogoHeaderWifiGreen} from './images/header-wifi-green.svg';
import {ReactComponent as LogoHeaderWifiRed} from './images/header-wifi-red.svg';
import {ReactComponent as LanguageWorld} from './images/world.svg';
import {useTranslation} from "react-i18next";
import {connectionErrorAtom} from "../../../store/ConnectionErrorStore";
import OnboardLanguageSelect from "../onboard-language-select-component/OnboardLanguageSelect";
import {useSafeNavigate} from '../../../util/useSafeNavigate';
import {setSimulationNumber} from '../../../util/SimulationManager';

const HeaderComponent = (props) => {
    const safeNavigate = useSafeNavigate();
    const simulationNumber = setSimulationNumber();
    const {t, i18n} = useTranslation();
    const {title, content, showBack, route, informationSet, informationSetStep} = props;
    const user = useRecoilValue(userAtom);
    const connectionError = useRecoilValue(connectionErrorAtom);
    const [languageOpen, setLanguageOpen] = useState(false);

    const getLanguage = () => {
        if (i18n !== undefined && i18n?.language !== null && i18n.language !== undefined) {
            let lang = i18n?.language?.toUpperCase();
            if (lang.includes("-"))
                return lang.split("-")[0];
            return lang;
        }
        return "EN";
    }

    let header = user?.business ? 'header header-business' : 'header';
    return (
        <div className={header}>
            <div className="header-parallex">
                <div className="header-top">
                    {showBack &&
                        <div className="header-back"
                             onClick={() => {
                                 if (informationSet !== undefined)
                                     simulationNumber(informationSet, informationSetStep);
                                 route ? safeNavigate(route) : safeNavigate("/login")
                             }}>
                            <LogoBack/>
                            <p className="header-back-text">{t('back')}</p>
                        </div>
                    }
                    {!connectionError &&
                        <div className="header-parallex-service">
                            <LogoHeaderWifiGreen/>
                            <p>{t('header_service.available')}</p>
                        </div>
                    }
                    {connectionError &&
                        <div className="header-parallex-unservice">
                            <LogoHeaderWifiRed/>
                            <p>{t('header_service.unavailable')}</p>
                        </div>
                    }
                </div>
                <div className="header-parallex-header">
                    <p className="header-parallex-title">{parse(title)}</p>
                    <div className="header-parallex-language" onClick={() => setLanguageOpen(true)}>
                        <LanguageWorld/>
                        <p>{getLanguage()}</p>
                    </div>
                </div>
                <p className="header-parallex-content">{content !== undefined ? parse(content) : ''}</p>
            </div>

            <OnboardLanguageSelect visible={languageOpen}
                                   onClose={() => setLanguageOpen(false)}/>

        </div>
    )
};

export default HeaderComponent;
